import _document from 'global/document';
import _window from 'global/window';
import _resizeObserver from 'resize-observer-polyfill';
export var document = _document;
export var window = _window;
export var IntersectionObserver = global.IntersectionObserver;
export var fetch = global.fetch;
export var ResizeObserver = _resizeObserver;
export var localStorage = global.localStorage;
export var navigator = window.navigator || {
  userAgent: 'unknown',
  platform: 'unknown'
}; // Server side rendering
// TODO: do not overload `location` and just don't call it in other files.
// having to use `as Location` is a big code smell

if (typeof window.location === 'undefined') {
  window.location = {
    origin: 'http://localhost'
  };
}

export var IS_APP_DESKTOP = 'electron' in window;
export var IS_MAC = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
export var IS_CHROME = Boolean(window.chrome);
export var IS_FIREFOX = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
export var IS_EDGE = navigator.userAgent.toLowerCase().indexOf('edg') !== -1;
export var IS_SAFARI = !!navigator.userAgent.match(/safari/i) && !navigator.userAgent.match(/chrome/i) && navigator.userAgent.match(/version\/12/i) && typeof document.body.style.webkitFilter !== 'undefined' && !window.chrome || !!navigator.userAgent.match(/(ipad|iphone|ipod)/i);
export default {
  IS_APP_DESKTOP: IS_APP_DESKTOP,
  IS_MAC: IS_MAC,
  IS_CHROME: IS_CHROME,
  IS_FIREFOX: IS_FIREFOX,
  IS_SAFARI: IS_SAFARI,
  IS_EDGE: IS_EDGE,
  navigator: navigator,
  window: window,
  document: document,
  IntersectionObserver: IntersectionObserver,
  ResizeObserver: ResizeObserver,
  fetch: fetch,
  localStorage: localStorage
};